export const FILES_GET_REQUESTED = 'FILES_GET_REQUESTED';
export const FILES_GET_SUCCEED = 'FILES_GET_SUCCEED';
export const FILES_GET_FAILED = 'FILES_GET_FAILED';
